export interface FiltroEdicionMasivaDef {
    campo: string;
    label: string;
    tipo: 'input' | 'select' | 'input-typeahead';
    requiredMayusculas?: boolean;
}

/** Filtros de plaguicidas. */
export const FILTROS_CLASIFICACION_PLAGUICIDAS: FiltroEdicionMasivaDef[] = [
    {
        campo: 'nombreComercial',
        label: 'Nombre comercial',
        tipo: 'input',
        requiredMayusculas: true,
    },
    {
        campo: 'numeroRegistroIca',
        label: 'Registro ICA',
        tipo: 'input',
    },
    {
        campo: 'subgrupoId',
        label: 'Subgrupo',
        tipo: 'select',
    },
    {
        campo: 'funcionEspecificaId',
        label: 'Función específica',
        tipo: 'select',
    },
    {
        campo: 'grupoNutricionalId',
        label: 'Grupo nutricional',
        tipo: 'select',
    },
    {
        campo: 'ingredienteActivoId',
        label: 'Ingrediente activo',
        tipo: 'select',
    },
    {
        campo: 'nombreComunId',
        label: 'Nombre común',
        tipo: 'input-typeahead',
    },
    {
        campo: 'estadoValidacion',
        label: 'Estado',
        tipo: 'select',
    },
];

/** Filtros de fertilizantes. */
export const FILTROS_CLASIFICACION_FERTILIZANTES: FiltroEdicionMasivaDef[] = [
    {
        campo: 'nombreComercial',
        label: 'Nombre comercial',
        tipo: 'input',
        requiredMayusculas: true,
    },
    {
        campo: 'numeroRegistroIca',
        label: 'Registro ICA',
        tipo: 'input',
    },
    {
        campo: 'subgrupoId',
        label: 'Subgrupo',
        tipo: 'select',
    },
    {
        campo: 'funcionEspecificaId',
        label: 'Función específica',
        tipo: 'select',
    },
    {
        campo: 'grupoNutricionalId',
        label: 'Grupo nutricional',
        tipo: 'select',
    },
    {
        campo: 'ingredienteActivoId',
        label: 'Ingrediente activo',
        tipo: 'select',
    },
    {
        campo: 'nombreComunId',
        label: 'Nombre común',
        tipo: 'input-typeahead',
    },
    {
        campo: 'estadoValidacion',
        label: 'Estado',
        tipo: 'select',
    },
];

export const FILTROS_CLASIFICACION_COADYUVANTES: FiltroEdicionMasivaDef[] = [];
export const FILTROS_CLASIFICACION_ACONDICIONADOR: FiltroEdicionMasivaDef[] =
    [];
export const FILTROS_CLASIFICACION_NUTRICION_ANIMAL: FiltroEdicionMasivaDef[] =
[
    {
        campo: 'nombreComercial',
        label: 'Nombre comercial',
        tipo: 'input',
        requiredMayusculas: true
    },
    {
        campo: 'numeroRegistroIca',
        label: 'Registro ICA',
        tipo: 'input',
    },
    {
        campo: 'especieId',
        label: 'Especie',
        tipo: 'select',
    },
    {
        campo: 'etapaProductiva',
        label: 'Etapa productiva',
        tipo: 'select',
    },
    {
        campo: 'subgrupoId',
        label: 'Subgrupo',
        tipo: 'select',
    },
    {
        campo: 'funcionEspecificaId',
        label: 'Función específica',
        tipo: 'select',
    },
    {
        campo: 'grupoNutricionalId',
        label: 'Grupo nutricional',
        tipo: 'select',
    },
    {
        campo: 'ingredienteActivoId',
        label: 'Ingrediente activo',
        tipo: 'select',
    },
    {
        campo: 'nombreComunId',
        label: 'Nombre común',
        tipo: 'input-typeahead',
    },
    {
        campo: 'estadoValidacion',
        label: 'Estado',
        tipo: 'select',
    },
];;

const COLUMNAS: readonly [campo: string, label: string][] = [
    ['subgrupo', 'Subgrupo'],
    ['funcionEspecifica', 'Función específica'],
    ['grupoNutricional', 'Grupo nutricional'],
    ['ingredienteActivo', 'Ingrediente activo'],
    ['nombreComun', 'Nombre común'],
];

const COLUMNAS_NUTRICION_ANIMAL: readonly [campo: string, label: string][] = [
    ['especie', 'Especie'],
    ['etapaProductiva', 'Etapa productiva'],
    ['subgrupo', 'Subgrupo'],
    ['funcionEspecifica', 'Función específica'],
    ['grupoNutricional', 'Grupo nutricional'],
    ['ingredienteActivo', 'Ingrediente activo'],
    ['nombreComun', 'Nombre común'],
];

export const EDITA_MASIVA_COLUMNS = [
    {
        campo: 'producto',
        label: 'Producto',
        toHtml: true,
        activateFilter: false,
        width: '20%',
    },
    {
        campo: 'presentaciones',
        label: 'Presentaciones',
        toHtml: true,
        activateFilter: false,
        width: '15%',
    },
    ...COLUMNAS.map(([campo, label]) => ({
        campo,
        label,
        activateFilter: false,
    })),
    {
        campo: 'estadoValidacionHtml',
        label: 'Estado',
        toHtml: true,
        activateFilter: false,
    },
    {
        campo: 'observaciones',
        label: 'Observaciones',
        activateFilter: false,
    },
];

export const EDITA_MASIVA_COLUMNS_NUTRICION_ANIMAL = [
    {
        campo: 'producto',
        label: 'Producto',
        toHtml: true,
        activateFilter: false,
        width: '20%',
    },
    {
        campo: 'presentaciones',
        label: 'Presentaciones',
        toHtml: true,
        activateFilter: false,
        width: '15%',
    }, 
    ...COLUMNAS_NUTRICION_ANIMAL.map(([campo, label]) => ({
        campo,
        label,
        activateFilter: false,
    })),
    {
        campo: 'estadoValidacionHtml',
        label: 'Estado',
        toHtml: true,
        activateFilter: false,
    },
    {
        campo: 'observaciones',
        label: 'Observaciones',
        activateFilter: false,
    }
];